export const FORCE_NEW_EXPERIENCE = 'g2w-force-new-experience';
